function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/**
 * Context provided to Horizon bricks during activation. Provides
 * Locator to resolve singleton dependencies and a hook that allows a brick to
 * load other bricks on-demand.
 */ export var BrickContext = function BrickContext(locator) {
    "use strict";
    _class_call_check(this, BrickContext);
    _define_property(this, "locator", void 0);
    this.locator = locator;
};

//# sourceMappingURL=BrickContext.js.map